module.exports = __webpack_public_path__ + "media/audio5.bc96fbd1.mp3";